import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useCheckUserLoggedIn } from '../hooks/user/useCheckUserLoggedIn';
import { useNotification } from '../provider/ToastNotificationProvider';
import { browserStorage } from '../utils/browserStorage.util';

interface LoggedInUserOnlyProps {
  children: React.ReactNode;
}

export const LoggedInUserOnly = ({ children }: LoggedInUserOnlyProps) => {
  const location = useLocation();
  const { openNotification } = useNotification();
  const { isUserLoggedIn } = useCheckUserLoggedIn();

  useEffect(() => {
    if (!isUserLoggedIn) {
      browserStorage.setItem({
        storageType: 'sessionStorage',
        itemKey: 'storedPageForRedirection',
        value: location.pathname + location.search,
      });

      openNotification({
        message: '해당 기능을 이용하기 위해 로그인을 해주세요',
      });
    }
  }, [isUserLoggedIn, location.pathname, location.search]);

  if (isUserLoggedIn) {
    return <>{children}</>;
  }

  return <Navigate to={'/oauth/login'} />;
};
